import { Handshake } from "@phosphor-icons/react";
import { t } from "i18next";

import { AddPracticeTypeForm } from "@/components/Meditations/PracticeType";
import type { ModalProps } from "@/shared.types";
import { Circle, Heading, Modal } from "@/ui";

export const AddPracticeTypeModal = ({ show, onClose }: ModalProps) => {
  return (
    <Modal
      show={show}
      title={
        <div className="flex flex-col gap-y-2">
          <Heading
            containerClassName="items-center"
            heading={t("meditations.add_practice_type")}
            left={
              <Circle>
                <Handshake size={24} className="text-tertiary-800" />
              </Circle>
            }
          />
          <span className="text-base text-neutral-700">
            *{t("error.required_fields")}
          </span>
        </div>
      }
      onClose={onClose}
    >
      <AddPracticeTypeForm onClose={onClose} />
    </Modal>
  );
};
